/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseSupplier
 */
export interface GetDraftPaymentRequest200ResponseSupplier {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'bankNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'branchNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'accountType': GetDraftPaymentRequest200ResponseSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'accountNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseSupplier
     */
    'companyName': string | null;
}

export const GetDraftPaymentRequest200ResponseSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetDraftPaymentRequest200ResponseSupplierAccountTypeEnum = typeof GetDraftPaymentRequest200ResponseSupplierAccountTypeEnum[keyof typeof GetDraftPaymentRequest200ResponseSupplierAccountTypeEnum];


